<template>
  <div class="objects-views" v-loading="loader">
    <div class="list-objects tree">
      <div class="header-row">
        <div class="project-name">
          <span>{{ $route.query.name || $store.state.project.name }}</span>

          <router-link
            :to="`/dashboard/jobs/all${$route.query.plan ? '?plan=' + $route.query.plan + '&name=' + $route.query.name: ''}${$route.query.version ? '?version=' + $route.query.version + '&name=' + $route.query.name: ''}`">
            <img src="@/assets/settings.svg"/>
          </router-link>

          <div style="cursor: pointer; margin-left: 10px">
<!--            <router-link :to="`/dashboard/obj/all/inputs`">-->
              <i class="fa fa-edit" @click="editObject = true"></i>
<!--            </router-link>-->
          </div>

          <router-link  style="color: black; font-size: 22px; margin-left: 12px"  to="/dashboard/jobs-report-obj"><i class="el-icon-tickets"></i></router-link>
          <el-dialog
            title="Редактирование объекта"
            :visible.sync="editObject"
            width="30%"
          >
            <el-form>
              <router-link :to="`/dashboard/obj/all/inputs`">
                <el-button style="width: 100%">Привязка полей</el-button>
              </router-link>
              <div style="margin-top: 8px"></div>
              <router-link :to="`/dashboard/obj/all/inputs-show`">
                <el-button style="width: 100%">Настройка полей</el-button>
              </router-link>
            </el-form>
          </el-dialog>
        </div>
        <div>
        </div>
      </div>
      <div class="objects-buttons">
        <AddObject @update="newObject">
          <el-button class="add-new-object">+ Добавить объект</el-button>
        </AddObject>

        <div class="objects-buttons" v-if="!$route.query.version">
          <template v-if="!$route.query.plan">
            <ImportFromEstimate @update="fetchTree" style="margin-right: 10px"/>
            <ImportFromExcel @update="fetchTree"/>

          </template>
          <ImportFromExcelPlan v-else @update="fetchTree"/>

        </div>
        <div v-else class="objects-buttons">
          <ImportFromExcelVersion @update="fetchTree"/>
        </div>

        <div v-if="$route.query.version" class="objects-buttons">
          <ImportFromExcelVersionToDirective @update="fetchTree"/>
        </div>

      </div>
      <nested-draggable
        :isMain="true"
        @update="newObject"
        @input="updateTree"
        :value="list"
        v-if="list && list.length"
      />
      <div v-else class="warn">
        <el-alert
          title="У вас нет объектов"
          type="warning"
          description="Вы можете создать объект кликнув на кнопку в правом верхнем углу"
          show-icon
        >
        </el-alert>
      </div>
    </div>
  </div>
</template>

<script>
import nestedDraggable from '@/views/Dashboard/Objects/components/List';
import firebase from 'firebase';
import AddObject from '@/views/Dashboard/Objects/components/AddObject';
import {getChild} from '@/utils/getChild';
import {flatten} from '../../../utils/getChild';
import _ from 'lodash';
import ImportFromEstimate from "./components/ImportFromEstimate";
import ImportFromExcelPlan from "../Plan/ImportFromExcel";
import ImportFromExcel from "./components/ImportFromExcel";
import ImportFromExcelVersion from "./components/ImportFromExcelVersion";
import ImportFromExcelVersionToDirective from "./components/ImportFromExcelVersionToDirective";

export default {
  name: 'ObjectsIndex',
  components: {
    ImportFromExcelVersionToDirective,
    ImportFromExcelVersion,
    ImportFromExcel,
    ImportFromExcelPlan,
    ImportFromEstimate,
    AddObject,
    nestedDraggable,
  },


  methods: {
    fire() {
      if (this.$route.query.plan) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('plan')
          .doc(this.$route.query.plan)
      }

      if (this.$route.query.version) {
        return myFirestore
          .collection('projects')
          .doc(this.$store.state.project.id)
          .collection('versions')
          .doc(this.$route.query.version)
      }

      return myFirestore
        .collection('projects')
        .doc(this.$store.state.project.id)
    },
    async newObject() {
      await this.fetchTree();
      this.updateTree(this.list);
    },
    updateTree: _.debounce(function (tree) {
      this.list = [...tree];
      console.log(tree, 'tree')
      const jobs = flatten(this.list);

      jobs.forEach((job, i) => {
        console.log(job, 'job')
        this.update({...job, index: i});
      });

      let prefix = 'OBJECT'
      Object.keys(localStorage)
        .filter(key => key.startsWith(prefix))
        .map(key => localStorage.removeItem(key))
    }, 500),
    update(data) {
      this.fire()
        .collection('objects')
        .doc(data.id)
        .update({
          index: data.index,
          name: data.name || null,
          code: data.code || '',
          ignoreAnalytics: !!(data.ignoreAnalytics),
          parentId: data.parentId || null,
        });
    },
    fetchTree() {
      this.loader = true;
      const result = [];
      return this.fire()
        .collection('objects')
        .get()
        .then((data) => {
          data.forEach((subDoc) => {
            const data = subDoc.data();

            result.push({
              id: subDoc.id,
              index: data.index,
              name: data.name,
              code: data.code || '',
              ignoreAnalytics: data.ignoreAnalytics,
              objects: data.objects || [],
              parentId: data.parentId || undefined,
            });
          });
        }).finally(() => {
          this.list = getChild(_.orderBy(result, 'index', ['asc']));

          this.loader = false;
        }).catch((e) => {
          this.loader = false;
        });
    },
  },

  mounted() {
    this.fetchTree();
  },


  data() {
    return {
      list: [],
      loader: false,
      editObject: false,
    };
  },
};
</script>

<style lang="scss">
.objects-views {
  display: flex;
  flex-direction: column;
  align-items: center;

  .list-objects {
    max-width: 600px;
    width: calc(100% - 20px);
  }

  .project-name {
    font-size: 16px;
    margin-top: 42px;
    display: flex;
    align-items: flex-end;
    background: #fff;
    justify-content: flex-start;
    padding: 0 10px;
    font-weight: bold;
  }
}

.tree, .tree ul {
  font: normal normal 14px/20px Helvetica, Arial, sans-serif;
  list-style-type: none;
  padding: 0;
  position: relative;
  overflow: hidden;
}

.tree li {
  margin: 0;
  padding: 0 0 0 20px;
  position: relative;
}

.tree li::before, .tree li::after {
  content: '';
  position: absolute;
  left: 0;
}

/* horizontal line on inner list items */
.tree li::before {
  border-top: 1px solid #ccc;
  top: 24px;
  width: 20px;
  height: 0;
}

/* vertical line on list items */
.tree li:after {
  border-left: 1px solid #ccc;
  height: 100%;
  width: 0px;
  top: -55px;
}

.tree > li::after {
  top: -55px;
}

.tree > li:last-child::after {
  display: none !important;
}

.add-new-object {
  cursor: pointer;
}

.header-row {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-top: 40px;
}

.warn {
  margin-top: 20px;
}

.objects-buttons {
  margin-left: 10px;
  display: flex;
  @media screen and (max-width: 540px) {
    margin-left: 0;
    flex-direction: column;

    button {
      margin-bottom: 2px;
      width: 100%;
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/views/Dashboard/Objects/Index.vue